
































import { ButtonType, ModalSize } from '@getaccept/lib-ui';
import type { Integration } from '@getaccept/lib-shared/src/integrations/types/integration';
import type { PropType } from '@vue/composition-api';
import { computed, ref, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { SigningPageDocument } from '@getaccept/lib-shared/src/types/signing-page-document';

export default defineComponent({
  props: {
    recipient: { type: Object as PropType<SigningPageRecipient>, required: true },
    document: { type: Object as PropType<SigningPageDocument>, required: true },
    integration: { type: Object as PropType<Integration>, default: undefined },
    authId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const loading = ref(false);

    const shouldRender = computed((): boolean => props.integration !== undefined);

    const title = computed((): string => t('pay-with-authorize-dot-net'));

    const externalUrl = computed((): string => {
      if (props.integration.externalUrl === undefined) {
        return '';
      }
      if (!props.integration.externalUrl) {
        return `/auth/authorizenet/${props.document.id}/${props.recipient.id}/${props.authId}`;
      }
      return props.integration.externalUrl;
    });

    const handleClose = () => {
      emit('close');
    };

    return {
      ButtonType,
      ModalSize,
      loading,
      shouldRender,
      title,
      externalUrl,
      handleClose,
    };
  },
});
